import { GetStaticProps } from 'next'
import { trpc } from '~/api/client'
import { ssgHelper } from '~/api/ssrHelpers'
// TODO: refactor PackList into shared components outside of home
import { PacksDisplayListProvider } from 'components'
import { Packs } from '~/client/Packs/Packs'

export const PacksPage = () => {
  const query = trpc.useQuery(['soldPackData'])
  return (
    <PacksDisplayListProvider value={query.data}>
      <Packs />
    </PacksDisplayListProvider>
  )
}

export default PacksPage

export const getStaticProps: GetStaticProps = async () => {
  const ssr = await ssgHelper()
  await ssr.fetchQuery('soldPackData')

  return {
    props: {
      trpcState: ssr.dehydrate(),
    },
    revalidate: 5,
  }
}
